var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx } from "react/jsx-runtime";
import { Children, isValidElement, cloneElement } from 'react';
import { Switch } from 'react-router-dom';
import { useLanguage } from '../hooks';
var LanguageSwitch = function (_a) {
    var children = _a.children, _b = _a.basename, basename = _b === void 0 ? '' : _b, rest = __rest(_a, ["children", "basename"]);
    var language = useLanguage();
    return (_jsx(Switch, __assign({}, rest, { children: Children.map(children, function (child) { return (isValidElement(child) ? cloneElement(child, __assign(__assign({}, child.props), { path: "/" + language + basename + child.props.path, redirectPath: "/" + language + basename + child.props.redirectPath })) : child); }) }), void 0));
};
export default LanguageSwitch;
//# sourceMappingURL=LanguageSwitch.js.map